import TalentPoolComponent from './TalentPoolComponent';

export default TalentPoolComponent;
